<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-6 offset-md-3">
        <div class="signup-form">
          <form novalidate>
            <h2>Register</h2>
            <p class="hint-text">
              Create your account. It's free and only takes a minute.
            </p>
            <div
              class="form-group"
              :class="{
                'form-group--error': dirtyInvalid($v.form.firstName)
              }"
            >
              <input
                type="text"
                class="form-control"
                v-model="form.firstName"
                placeholder="First Name"
                required="required"
              />
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.firstName) && !$v.form.firstName.required
                "
                errorMessage="First Name is required"
              ></error-message>
            </div>
            <div
              class="form-group"
              :class="{
                'form-group--error': dirtyInvalid($v.form.lastName)
              }"
            >
              <input
                type="text"
                class="form-control"
                v-model="form.lastName"
                placeholder="Last Name"
                required="required"
              />
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.lastName) && !$v.form.lastName.required
                "
                errorMessage="Last Name is required"
              ></error-message>
            </div>
            <div
              class="form-group"
              :class="{
                'form-group--error': dirtyInvalid($v.form.username)
              }"
            >
              <input
                type="text"
                class="form-control"
                v-model="form.username"
                placeholder="username"
                required="required"
              />
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.username) && !$v.form.username.required
                "
                errorMessage="Username is required"
              ></error-message>
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.username) && !$v.form.username.minLength
                "
                errorMessage="Username must be at least 7 characters long"
              ></error-message>
            </div>
            <div
              class="form-group"
              :class="{
                'form-group--error': dirtyInvalid($v.form.emailAddress)
              }"
            >
              <input
                type="email"
                class="form-control"
                v-model="form.emailAddress"
                placeholder="Email Address"
                required="required"
              />
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.emailAddress) &&
                    !$v.form.emailAddress.required
                "
                errorMessage="Email Address is required"
              ></error-message>
            </div>
            <div
              class="form-group"
              :class="{
                'form-group--error': dirtyInvalid($v.form.password)
              }"
            >
              <input
                type="password"
                class="form-control"
                v-model="form.password"
                placeholder="Password"
                required="required"
              />
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.password) && !$v.form.password.required
                "
                errorMessage="Password is required"
              ></error-message>
            </div>
            <div
              class="form-group"
              :class="{
                'form-group--error': dirtyInvalid($v.form.confirmPassword)
              }"
            >
              <input
                type="password"
                class="form-control"
                v-model="form.confirmPassword"
                placeholder="Confirm Password"
                required="required"
              />
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.confirmPassword) &&
                    !$v.form.confirmPassword.required
                "
                errorMessage="Confirm Password is required"
              ></error-message>
              <error-message
                :errorCondition="
                  dirtyInvalid($v.form.confirmPassword) &&
                    !$v.form.confirmPassword.passwordsMustMatch
                "
                errorMessage="Password and Confirm Password must match"
              ></error-message>
            </div>
            <div class="form-group">
              <label class="checkbox-inline"
                ><input type="checkbox" required="required" /> I accept the
                <a href="#">Terms of Use</a> &amp;
                <a href="#">Privacy Policy</a></label
              >
            </div>
            <div class="form-group">
              <button
                type="button"
                @click.prevent="save()"
                class="btn btn-success btn-lg btn-block"
              >
                Register Now
              </button>
            </div>
          </form>
          <div class="text-center">
            Already have an account?
            <router-link to="/login">Sign in</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container" style="overflow-x: scroll;">
      <div class="row">
        <div class="col-12">{{ JSON.stringify($v.form) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators';
import AuthService from '../services/authentication-service';
import ToastrService from '../common/toastr-util';
import ErrorMessage from '../components/ErrorMessage.vue';
import { mixins } from '../mixins/mixins';

const passwordsMustMatch = (value, vm) => {
  return value === vm.password;
};

export default {
  name: 'register',
  mixins: [mixins],
  components: {
    ErrorMessage
  },
  data() {
    return {
      JSON,
      form: {
        username: '',
        firstName: '',
        lastName: '',
        emailAddress: '',
        password: '',
        confirmPassword: ''
      }
    };
  },
  validations: {
    form: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      username: {
        required,
        minLength: minLength(7)
      },
      emailAddress: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      confirmPassword: {
        required,
        passwordsMustMatch
      }
    }
  },
  methods: {
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        AuthService.register(this.form)
          .then(resp => {
            if (resp.data.error && resp.data.error.message) {
              ToastrService.toast('error', resp.data.error.message);
            } else {
              ToastrService.toast('success', 'Thank you for registering!');
              this.$router.push({ path: '/login' });
            }
          })
          .catch(resp => {
            console.log(JSON.stringify(resp));
            ToastrService.toast(
              'error',
              'There was a problem with registration. Please try again later'
            );
          });
      }
    }
  }
};
</script>

<style scoped>
.form-group--error input {
  color: red;
  border-color: red;
}
</style>
